import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT } from '../../../styles/constants';

const safeArea = {
  top: 'env(safe-area-inset-top, 0px)',
  right: 'env(safe-area-inset-right, 0px)',
  bottom: 'env(safe-area-inset-bottom, 0px)',
  left: 'env(safe-area-inset-left, 0px)',
} as const;
const layoutBottomGap = 'var(--vv-layout-bottom-gap, 0px)';
const bottomInset = `calc(${safeArea.bottom} + var(--vv-layout-bottom-gap, 0px))`;

export const useStyles = makeStyles<Theme>()((theme) => ({
  choosePlanDialogWrapper: {
    width: '100dvw',
    height: MAX_PAGE_HEIGHT,
    maxWidth: 'unset',
    margin: 0,
    maxHeight: MAX_PAGE_HEIGHT,
    borderRadius: '10px',
    [theme.breakpoints.down('md')]: {
      height: MAX_PAGE_HEIGHT,
      maxHeight: MAX_PAGE_HEIGHT,
      marginTop: safeArea.top,
      marginBottom: bottomInset,
      marginLeft: safeArea.left,
      marginRight: safeArea.right,
    },
  },
  choosePlanDialogHeader: {
    padding: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    ...theme.mixins.appSvg,
  },
  choosePlanDialogTitle: {
    padding: '64px 0 32px',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '32px',
    lineHeight: '48px',
    margin: '0',
    [theme.breakpoints.down('md')]: {
      paddingTop: 0,
    },
  },
  choosePlanDialogContainer: {
    [theme.breakpoints.down('md')]: {
      maxHeight: 'calc(100% - 212px)',
      height: 'calc(100% - 212px)',
    },
  },
  subscriptionLimitNotice: {
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));
